var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cells.length)?_c('ParticularsSection',{attrs:{"title":"General"}},_vm._l((_vm.cells),function(cell){return _c('ParticularsCell',{key:cell.label,attrs:{"label":cell.label}},[_c('p',[_vm._v(_vm._s(cell.value))])])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }